<template>
<div :id="options.id" v-bind:class="setStyleContainer(options.cssContainer)">
<div class="table-header-wrapper">
  <table :id="options.id+'h'" v-bind:class="setStyleHeader(options.cssHeader)">
    <tr>
      <th v-for="col in columns" :key="col.id" :data-column-name="col.id" :width="col.width ? col.width : '100'" v-bind:class="setStyleCell(col,'th')" v-on:click.prevent="colClick(col,row)">
        {{col.title}}
        <span class="icon is-small is-pulled-right" v-if="col.order>=0">
          <img width="16" height="16" v-if="options.order_col==col.id" v-bind:src="[col.order==1 ? 'icon_sort_down_red.png' : 'icon_sort_up_red.png']" v-on:click.prevent="handleOrderDir(col)">
          <img width="16" height="16" v-else v-bind:src="['icon_sort.png']" v-on:click.prevent="handleOrderDir(col)">
        </span>
      </th>
      <template v-if="scrollbarVisible()">
        <th width="18"></th>
      </template>
    </tr>
  </table>
</div>
<div :id="options.id+'bw'" class="table-body-wrapper">
  <table :id="options.id+'b'" v-bind:class="setStyleBody(options.cssBody)">
    <tr v-for="row in wrows" :key="row.id" v-bind:class="options.cssRows">
      <td v-for="col in columns" :key="col.id" :width="col.width ? col.width : '100'" v-bind:class="setStyleCell(col,'td',row==selectedItem,row)" v-on:mouseup.prevent="colMouseup($event,options.id,col,row)" v-on:mousedown.prevent="colMousedown($event,options.id,col,row)" v-on:click="colClick(options.id,col,row)">
        <template v-if="col.image">
          <span class="icon is-small">
            <template v-if="col.image_name.length==0">
              <img v-bind:src="$parent.get_image(col.id,row[col.id])">
            </template>
            <template v-else>
              <img v-bind:src="col.image_name">
            </template>
          </span>
        </template>
        <template v-else-if="col.checkbox">
          <input type="checkbox" v-model="row[col.id]">
        </template>
        <template v-else>
          {{formatCellValue(row[col.id],row[col.f_type_id],col.f_type,col.filter)}}
        </template>
      </td>
    </tr>
  </table>
</div>
</div>
</template>
<script>
  export default {
    name: 'VueScrollTable',
    props: {
      options: {
        type: Object
      },
      selectedItem:{
       type: Object
      },
      columns: {
        type: Array
      },
      rows: {
        type: Array
      }
    },

    data: function() {
      var data = {
        windowHeight: 0,
        windowWidth: 0,
        grips: [],
        viewMenu: false,
        top: '0px',
        left: '0px',
        mouse_ref:null,
        mouse_bk:null
      }
      return data
    },
    computed: {
      wrows: function() {
        const vm = this
        if (vm.options!==null && vm.options!==undefined){
         var col = vm.findColByKey('id', vm.options.order_col)
         vm.sortRows(col)
        }
        return vm.rows
      }
    },
    mounted() {
      this.$nextTick(function() {
        const vm = this

        vm.container = document.getElementById(vm.options.id)
        vm.header = document.getElementById(vm.options.id+"h")
        vm.body = document.getElementById(vm.options.id+"b")
        vm.overflow = document.getElementById(vm.options.id+"bw")

        window.addEventListener('resize', this.getWindowSize)
        vm.getWindowSize()
        vm.doResetColumns()

         if(vm.options.isResizeable) {
              vm.setResizeGrips()
              }
      })
    },
    methods: {
      doResetColumns(){
        const vm=this
        vm.$parent.initColumns()
       setTimeout(function(){ vm.recalcColumnsSize()},40)
      },
      doSaveCookie(){
       const vm = this
      var myCookie = {
        order_col: vm.options.order_col,
        columns: vm.columns
      }
      vm.$cookie.set(vm.options.id, JSON.stringify(myCookie), 365);
      },
      setId(name) {
        return this.options.id + name
      },
      sortRows(col) {
        const vm = this
        if (col !== null){
        if(col.order == 0) {
          vm.rows.sort(function(a, b) {
            return (a[col.id]===null)-(b[col.id]===null) || +(a[col.id]>b[col.id])||-(a[col.id]<b[col.id]);
          });
        } else {
          vm.rows.sort(function(a, b) {
            return (a[col.id]===null)-(b[col.id]===null) || -(a[col.id]>b[col.id])||+(a[col.id]<b[col.id]);
          });
        }
          }
      },
      findColByKey(key, value) {
        const vm = this
        for(var i = 0; i < vm.columns.length; i++) {
          if(vm.columns[i][key] === value) {
            return vm.columns[i];
          }
        }
        return null;
      },
      onMouseDown(e) {
        const vm = this
        vm.thElm = e.target.parentNode
        vm.startOffset = vm.thElm.offsetWidth - e.pageX
      },
      onMouseMove(e) {
        const vm = this
         if(vm.thElm) {
          const width = vm.startOffset + e.pageX
          vm.thElm.width = width + 'px'
          vm.syncColumnWidths()
        }
      },
      onMouseUp() {
        const vm = this
        vm.thElm = undefined
      },
      syncColumnWidths() {
        const vm = this
        const headerCols = Array.from(vm.header.getElementsByTagName('th'))
        const widths = headerCols.map((h) => h.width ? h.width : h.clientWidth)
        const bodyCols = Array.from(vm.body.querySelectorAll('tr:first-child>td'))
        bodyCols.forEach((c, i) => {
          this.columns[i].width = parseInt(widths[i])
        })
        this.recalcColumnsSize()
      },
      colMouseup(){
        const vm=this
        if (vm.mouse_ref!==null){
            vm.mouse_ref.style.backgroundColor=vm.mouse_bk;
          }
          vm.mouse_ref=null
       },
      colMousedown(e,id,col){
        if (col.mousefeedback===true){
        const vm=this
        vm.mouse_ref=e.srcElement;
        vm.mouse_bk= vm.mouse_ref.style.backgroundColor;
        vm.mouse_ref.style.backgroundColor="lightgray";
        }
      },
      colClick(id,col,row){
        console.log("click")
        const vm=this
        if (col.checkbox) {
          if (vm.$parent.colCheckbox){
          vm.$parent.colCheckbox(id,col,row)
            }
            else
            {
            console.log("colCheckbox is not implemented in parent");
            }
        }
        else
        if ( vm.options.isSelectable){
          if (vm.$parent.colClick){
          vm.$parent.colClick(id,col,row)
            }
            else
            {
            console.log("colClick is not implemented in parent");
            }
        }
      },
      handleOrderDir(col) {
        const vm = this
        vm.options.order_col = col.id;
        col.order = 1 - col.order;
        vm.sortRows(col)
      },
      setResizeGrips() {
        const vm = this
        const headerCols = Array.from(vm.header.getElementsByTagName('th'))
        headerCols.forEach((th) => {
          th.style.position = 'relative'
          const grip = document.createElement('div')
          grip.className = 'grip'
          grip.innerHTML = '&nbsp'
          grip.style.top = 0
          grip.style.right = 0
          grip.style.bottom = 0
          grip.style.width = '5px'
          grip.style.position = 'absolute'
          grip.style.cursor = 'col-resize'
          grip.addEventListener('mousedown', vm.onMouseDown)
          th.appendChild(grip)
          vm.grips.push(grip)
        })
        document.addEventListener('mousemove', vm.onMouseMove)
        document.addEventListener('mouseup', vm.onMouseUp)
      },
      setStyleContainer(sContainer) {
        if(sContainer === null || sContainer === undefined || sContainer === "") {
          sContainer = "table-container"
        }
        return sContainer;
      },
      setStyleHeader(sHeader) {
        if(sHeader === null || sHeader === undefined || sHeader === "") {
          sHeader = "table-header"
        }
        return sHeader;
      },
      setStyleBody(sBody) {
        if(sBody === null || sBody === undefined || sBody === "") {
          sBody = "table-body"
        }
        return sBody;
      },
      setStyleCell(colObj, cellType, isSelected, data) {
        var alignmentSet
        var styleSet
        var color=""
        if(cellType == 'th') {
          alignmentSet = colObj.alignment_th;
          styleSet = colObj.style_td;
        } else {
          alignmentSet = colObj.alignment_td;
          styleSet = colObj.style_td
        }
        if(alignmentSet === null || alignmentSet === undefined || alignmentSet === "") {
          alignmentSet = "left_align"
        }
        if(styleSet === null || styleSet === undefined || styleSet === "") {
          styleSet = "cell"
        }

        if (colObj.calcColor && cellType == 'td'){
          switch (data.mode){
          case '2': color="sr_black"
                  break
          case '1': color="sr_red"
                  break
          case '0': color="sr_green"
                  break
        }
        }
        else
        {
          color="sr_black"
        }

        if(cellType == 'th') {
          return alignmentSet + " " + styleSet;
        } else {
          if (isSelected ){
          return alignmentSet + " " + styleSet +" "+'isSelected'+" "+color;
          }
          else
          {
          return alignmentSet + " " + styleSet+" "+color;
          }
        }
      },
      ddToDms_lat(lat) {
        var latResult;
        lat = parseFloat(lat);
        latResult = (lat >= 0)? 'N ' : 'S ';
        latResult += this.getDms(lat);
        return latResult;
      },
      ddToDms_lon(lng) {
        var lngResult;
        lng = parseFloat(lng);
        lngResult = (lng >= 0)? 'E ' : 'W ';
        lngResult += this.getDms(lng);
        return lngResult;
      },
      getDms(val) {
        var valDeg, valMin, valSec, result;
        val = Math.abs(val);
        valDeg = Math.floor(val);
        result = valDeg + "\u00BA ";
        valMin = Math.floor((val - valDeg) * 60);
        result += valMin + "' ";
        valSec = Math.round((val - valDeg - valMin / 60) * 3600 * 1000) / 1000;
        result += valSec + '" ';
        return result;
      },
      formatCellValue(value, value_f_type, col_f_type, filter) {
        const vm=this
        var res=value;

         if (value===null) return ""

         if (col_f_type === "*" || value_f_type===col_f_type) {
        switch(filter) {
          case 'mssg_filter':
            res=value.split("[")[0]
            break
          case 'pipe_filter':
            res = value.replace(/\|/g, " ")
            break
          case 'date_reverse_filter': {
            var dd1 = value.split(" ");
            res = dd1[0].split("-").reverse().join("-") + " " + dd1[1]
            break
          }
          case 'date_reverse_solo_filter': {
            var dd2 = value.split(" ");
            res = dd2[0].split("-").reverse().join("-")
            break
          }
           case 'num.########':
            res = value.toLocaleString( undefined, { maximumFractionDigits:8 })
            break
          case 'num.####':
            res = value.toLocaleString( undefined, { maximumFractionDigits:4 })
            break
           case 'num.#':
            res = value.toLocaleString( undefined, { maximumFractionDigits:1 })
            break
           case 'DD2DMS_lat':
              res=vm.ddToDms_lat(value)
             break
            case 'DD2DMS_lon':
              res=vm.ddToDms_lon(value)
              break
        }
        return res
        }
        else
        {
          return ""
        }
      },
      recalcColumnsSize() {
        const vm = this

        var sumColsLength = 0
        var delta
        var elastic = []
        for(var i = 0; i < vm.columns.length; i++) {
          sumColsLength += vm.columns[i].width;
          if(vm.columns[i].elastic) {
            elastic.push(vm.columns[i]);
          }
        }
        delta = (vm.windowWidth -16) - sumColsLength;

        if(delta == 0) return;
        if (elastic.length>0){
        if(elastic.length > 1) {
          elastic.sort(function(a, b) {
            return(a.width > b.width) ? 1 : ((b.width > a.width) ? -1 : 0);
          });

           var f = 0;
          var d;
          for(i = 0; i < elastic.length; i++) {
            f += elastic[i].width / elastic[0].width;
          }
          d = delta / f;

          for(i = elastic.length - 1; i >= 0; i--) {
            elastic[i].width = elastic[i].width + Math.trunc((elastic[i].width / elastic[0].width) * d);
          }
        } else {
          elastic[0].width += delta;
        }
        }
        else
        {
          console.log("recalcColumnsSize")
           document.getElementById(vm.options.id+"bw").setAttribute("style", "width:" + sumColsLength + 'px')
        }
      },
      scrollToVisible(idx){
        const vm = this
        var hTr= vm.body.rows[0].clientHeight
        var posTr= idx*hTr+hTr
        var delta = posTr - vm.overflow.clientHeight
        if (delta>0){
          vm.overflow.scrollTop=delta+(vm.overflow.clientHeight/2)
        }
      },
      scrollbarVisible() {
        if (typeof(this.overflow) != "undefined"){
          return this.overflow.scrollHeight > this.overflow.clientHeight;
        }
        else
        {
          return false
        }
      },
      getWindowSize() {
        const vm = this
        vm.windowHeight = document.documentElement.clientHeight;
        vm.windowWidth = vm.container.clientWidth;
        vm.recalcColumnsSize();
       },
    },
    beforeDestroy() {
      window.removeEventListener('resize', this.getWindowSize)
      document.removeEventListener('mousemove', this.onMouseMove)
      document.removeEventListener('mouseup', this.onMouseUp)
    }
  }
</script>
<style>

.table_list_header {
    font-family: Arial, Helvetica, sans-serif;
    font-size:10px;
    height:30px;
    background-color:whitesmoke;
}

.table_list{
    font-family: Arial, Helvetica, sans-serif;
    font-size: 11px;
}

tr.table_list:nth-child(even) {background-color: #f2f2f2;}

  .table-container {  }

  .table-header {
    font-family: Arial, Helvetica, sans-serif;
    font-size: 12px;
    font-weight: bold;
  }

  .table-body {
    font-family: Arial, Helvetica, sans-serif;
    font-size: 12px;
     border-right: 1px solid #BDBDBD;
  }

  .table-body-wrapper {
    overflow-y: auto;
    height: 100%;
    width:100%;
  }

  .left_align {
    text-align: left !important;
  }

  .right_align {
    text-align: right !important;
  }

  .center_align {
    text-align: center !important;
  }

  .cell {
    padding: 4px;
    border: 1px solid #ddd;
  }

  .isSelected{
    background: lightgray;
  }

  #right-click-menu{
    background: #FAFAFA;
    border: 1px solid #BDBDBD;
    box-shadow: 0 2px 2px 0 rgba(0,0,0,.14),0 3px 1px -2px rgba(0,0,0,.2),0 1px 5px 0 rgba(0,0,0,.12);
    display: block;
    list-style: none;
    margin: 0;
    padding: 0;
    position: absolute;
    width: 350px;
    z-index: 999999;
}

#context-menu li {
    border-bottom: 1px solid #E0E0E0;
    margin: 0;
    padding: 5px 35px;
}

#context-menu li:last-child {
    border-bottom: none;
}

#context-menu li:hover {
    background: #1E88E5;
    color: #FAFAFA;
}
.trunc {
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

</style>
